import config from "@/config"

export const domain = config.API_DOMAIN;
export const url = config.API_URL;
